export const formatDateTimeKST = (dateString) => {
  if (!dateString) return '-';
  
  const date = new Date(dateString);
  
  // Convert to KST (UTC+9)
  const kstOffset = 9 * 60; // 9 hours in minutes
  const utcTime = date.getTime() + (date.getTimezoneOffset() * 60000);
  const kstTime = new Date(utcTime + (kstOffset * 60000));
  
  // Format as YYYY-MM-DD HH:MM
  const year = kstTime.getFullYear();
  const month = String(kstTime.getMonth() + 1).padStart(2, '0');
  const day = String(kstTime.getDate()).padStart(2, '0');
  const hours = String(kstTime.getHours()).padStart(2, '0');
  const minutes = String(kstTime.getMinutes()).padStart(2, '0');
  
  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

export const formatDateKST = (dateString) => {
  if (!dateString) return '-';

  const date = new Date(dateString);

  // Convert to KST (UTC+9)
  const kstOffset = 9 * 60; // 9 hours in minutes
  const utcTime = date.getTime() + (date.getTimezoneOffset() * 60000);
  const kstTime = new Date(utcTime + (kstOffset * 60000));

  // Format as YYYY-MM-DD
  const year = kstTime.getFullYear();
  const month = String(kstTime.getMonth() + 1).padStart(2, '0');
  const day = String(kstTime.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

/**
 * Format a number with up to maxDecimals decimal places, removing trailing zeros.
 * e.g., formatDecimal(3.000, 3) => "3"
 *       formatDecimal(3.100, 3) => "3.1"
 *       formatDecimal(3.123, 3) => "3.123"
 *       formatDecimal(3.1234, 3) => "3.123"
 *
 * @param {number} value - The number to format
 * @param {number} maxDecimals - Maximum decimal places (default: 3)
 * @returns {string} Formatted number string without trailing zeros
 */
export const formatDecimal = (value, maxDecimals = 3) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '-';
  }
  // Use toFixed to limit decimals, then parseFloat to remove trailing zeros, then toString
  return parseFloat(Number(value).toFixed(maxDecimals)).toString();
};

/**
 * Format a number with exactly fixedDecimals decimal places (with zero-padding).
 * e.g., formatDecimalFixed(3, 3) => "3.000"
 *       formatDecimalFixed(3.1, 3) => "3.100"
 *       formatDecimalFixed(3.123, 3) => "3.123"
 *       formatDecimalFixed(3.1234, 3) => "3.123"
 *
 * @param {number} value - The number to format
 * @param {number} fixedDecimals - Exact decimal places (default: 3)
 * @returns {string} Formatted number string with zero-padding
 */
export const formatDecimalFixed = (value, fixedDecimals = 3) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '-';
  }
  return Number(value).toFixed(fixedDecimals);
};

/**
 * Format a number with comma separators for thousands.
 * e.g., formatWithCommas(1000000) => "1,000,000"
 *       formatWithCommas(1234.56) => "1,234.56"
 *
 * @param {number|string} value - The number to format
 * @returns {string} Formatted number string with commas
 */
export const formatWithCommas = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  const num = Number(value);
  if (isNaN(num)) {
    return value.toString();
  }
  return num.toLocaleString('en-US');
};

/**
 * Remove commas from a formatted number string.
 * e.g., removeCommas("1,000,000") => "1000000"
 *
 * @param {string} value - The formatted string with commas
 * @returns {string} String without commas
 */
export const removeCommas = (value) => {
  if (value === null || value === undefined) {
    return '';
  }
  return value.toString().replace(/,/g, '');
};